import { Component, OnInit, inject } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Column,
  DataTableComponent,
  EmptyTableComponent,
  NimmstaDataSource,
} from '@nimmsta/ng-commons-lib/data-table';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { NimmstaTimeAgoPipe } from '@nimmsta/ng-commons-lib/pipes';
import { LightTag } from '../../models/lighttag';
import { LightTagAdminService } from '../../services/lighttag-admin.service';
import { TranslatePipe } from '@ngx-translate/core';

_('lighttag.title');

@Component({
    templateUrl: 'lighttag-admin.component.html',
    selector: 'app-lighttag-admin',
    imports: [DataTableComponent, EmptyTableComponent, ErrorComponent, TranslatePipe],
    providers: [NimmstaTimeAgoPipe],
})
export class LightTagAdminComponent implements OnInit {
  private lighttagService = inject(LightTagAdminService);
  private timeago = inject(NimmstaTimeAgoPipe);

  lighttagSource!: NimmstaDataSource<LightTag>;

  error?: HttpErrorResponse;

  get columns(): Column[] {
    return [
      new Column('serialNr', 'lighttag.serialNr', { sortable: true }),
      new Column('soldOrganization.title', 'lighttag.soldOrganization.name', { sortable: true }),
      new Column('organization.title', 'lighttag.organization.name', { sortable: true }),
      new Column('lastLocation', 'lighttag.lastLocation', { sortable: true }),
      new Column('lastSeen', 'lighttag.lastSeen', { pipe: this.timeago, sortable: true, invertSorting: true }),
      new Column('lastIlluminated', 'lighttag.lastSeen', { pipe: this.timeago, sortable: true }),
      new Column('lastBatteryStatus', 'lighttag.lastBatteryStatus', { sortable: true }),
    ];
  }

  ngOnInit(): void {
    this.lighttagSource = new NimmstaDataSource<LightTag>(this.lighttagService);
  }
}
